export default {
  meta: {
    title: '变更记录详情'
  }
};
